// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bgs/XDL/types";

export default {
    primary: {
        main: "#9ECFC2",
        contrast: "#FFFFFF",
        active: "#82AFA3",
    },
    secondary: {
        main: "#DED2AA",
        contrast: "#FFFFFF",
        active: "#C6BB98",
    },
    tertiary: {
        main: "#9C822F",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#333F48",
        accent: "#F8F9FA",
        accentContrast: "#333F48",
        border: "#6D7878",
        disabled: "#EBEBEB",
        mktg1: "#734098",
        mktg2: "#fdba1e",
        mktg3: "#05bdd9",
        mktg4: "#128e7a",
        mktg5: "#df564b",
        mktg6: "#223a74",
        ui1: "#6F6F71",
        ui2: "#B0B0B7",
        ui3: "#DEDEDE",
        ui4: "#F3F3F3",
        ui5: "#2F2F2F",
        ui6: "#df564b",
        ui7: "#818186",
        ui8: "#75757A",
        ui9: "#DDDDE5",
        ui10: "#4C4C4E",
        ui11: "#4D4D4F",
        ui12: "#98988F",
        ui13: "#FFFFF0",
        primary1: "#9ECFC2",
        primary2: "#DED2AA",
        primary3: "#9C822F",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#131313",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#6F6F71",
    },
    success: {
        main: "#5CB85C",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#DA002E",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#F0AD4E",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#5BC0DE",
        contrast: "#FFFFFF",
    },
    transparent: {
        main: "transparent",
        contrast: "#424242",
    },
} as xBaseTheme["colors"];
